export enum ModalCommandActions {
  ADD = 'ADD',
  APPLY = 'APPLY',
  CANCEL = 'CANCEL',
  CHANGE = 'CHANGE',
  CHECK_BALANCE = 'CHECK_BALANCE',
  CLOSE = 'CLOSE',
  CONTINUE = 'CONTINUE',
  DONE = 'DONE',
  MANUAL_ENTRY = 'MANUAL_ENTRY',
  REMOVE = 'REMOVE',
  RETRY = 'RETRY',
  SCAN = 'SCAN',
  SEARCH = 'SEARCH',
  SELECT_ROW = 'SELECT_ROW',
  TIMEOUT = 'TIMEOUT',
  VOICE_AUTH = 'VOICE_AUTH',
  PRINT = 'PRINT',
  ENTER_SUPPORT_MODE = 'ENTER_SUPPORT_MODE',
}

export enum ModalContentAlign {
  LEFT = 'content-aligned-left',
  CENTER = 'content-centered',
  RIGHT = 'content-aligned-right',
}
